<template>
  <div class="program">
    <div class="program-box">
      <Nav />
      <div class="project-overview-policy-data-wrap" v-if="hasData">
        <div class="policy-data-form-wrap">
          <el-card class="cardTab" shadow="never" v-for="item in formStructData" :key="item.id">
            <form-struct
              :form-data="item.formTemplateStructDataList"
              :isEdit="isEdit"
              :is-project="true"
              :show-flag="true"
              :template-id="templateId"
            ></form-struct>
          </el-card>
        </div>
      </div>
      <div style="height:80%" v-else>
        <None />
      </div>
    </div>
  </div>
</template>
<script>
import Nav from '@/components/nav.vue';
import None from '@/components/none.vue';
import { queryCompensationScheme } from '@/api/publicinquiry.api.js';
import { preDataProcessShow } from '@/untils/preDataProcess';
import FormStruct from '@/components/FormStruct.vue';
import { setSession, getSession } from '@/untils';
export default {
  components: {
    Nav,
    FormStruct,
    None
  },
  computed:{
    hasData() {
      return this.dataList.length > 0
    }
  },
  data() {
    return {
      formStructData: [],
      dataList: [],
      isEdit: false,
      templateId: ''
    };
  },
  methods: {
    queryCompensationScheme() {
      queryCompensationScheme(this.projectId).then(res => {
        const result = preDataProcessShow(res.body);
        this.templateId = result[0] && result[0].templateId;
        this.formStructData = result;
        this.dataList = result[0].formTemplateStructDataList
        // this.templateId = res;
      });
    }
  },
  created() {
    this.projectId = getSession('projectId');
    this.queryCompensationScheme();
  }
};
</script>
<style>
.program {
  height: 100%;
}
.program-box {
  height: 100%;
  background: #ffffff;
}
.project-overview-policy-data-wrap {
  overflow: auto;
  height: calc(100% - 53px);
  padding: 10px 30px;
}
</style>



// WEBPACK FOOTER //
// src/page/project-system/program/index.vue